// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WaterMark_watermark_p__w5CYD {
    color:rgb(117 116 116 / 32%);
    pointer-events: none;
    line-height: 0 !important;
  }
  
  .WaterMark_watermark__I0RCh {
    z-index: 99;
    width: 60%;
    position: absolute;
    text-align: center;
    font-size: 15px;
    top: 35%;
    left: 25%;
    pointer-events: none;
  }`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard_Coral/DashboardMain_Coral/WaterMark.module.css"],"names":[],"mappings":"AAAA;IACI,4BAA4B;IAC5B,oBAAoB;IACpB,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,QAAQ;IACR,SAAS;IACT,oBAAoB;EACtB","sourcesContent":[".watermark_p {\n    color:rgb(117 116 116 / 32%);\n    pointer-events: none;\n    line-height: 0 !important;\n  }\n  \n  .watermark {\n    z-index: 99;\n    width: 60%;\n    position: absolute;\n    text-align: center;\n    font-size: 15px;\n    top: 35%;\n    left: 25%;\n    pointer-events: none;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"watermark_p": `WaterMark_watermark_p__w5CYD`,
	"watermark": `WaterMark_watermark__I0RCh`
};
export default ___CSS_LOADER_EXPORT___;
